import { defineComponent as _defineComponent } from 'vue'
import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import { OnClickOutside } from '@vueuse/components';
  import BaseDivider from '@ui/atoms/baseDivider/BaseDivider.vue';
  import { ref, computed, watch, onUnmounted } from 'vue';
  import { RICH_TEXT } from '@/constant/richText';
  import { Font } from '@/components/common/fontSelector/types';
  import { useStore } from '@/store';

  
  const __default__ = {
    name: 'FontSelector',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { type: String, required: true, default: RICH_TEXT.DefaultFontFamily },
    disabled: { type: Boolean, default: false },
    relative: { type: Boolean, default: true },
    fonts: { type: Array, default: () => [] },
    noAutoScroll: { type: Boolean, default: false },
    noBrandFonts: { type: Boolean, default: false },
    maxHeight: { type: Number, default: 500 },
    width: { type: Number, default: 323 },
  },
  emits: ["update:value"],
  setup(__props, { emit }: { emit: ({
    (event: 'update:value', value: string): void;
  }), expose: any, slots: any, attrs: any }) {

const { value, disabled, fonts, noAutoScroll, noBrandFonts, maxHeight, width } = __props;

  

  const store = useStore();

  

  const userFonts = computed(() => {
    return fonts && fonts.length > 0 ? fonts : store.getters.userFonts;
  });

  const brandFonts = ref(store.getters.getBrandFonts);

  const defaultFonts = ref([RICH_TEXT.DefaultFontFamily]);
  const selectedFont = ref(value);
  const isActive = ref(false);
  const searchQuery = ref('');

  const fontFamilyButton = ref(null);
  const fontsModal = ref(null);
  const searchInput = ref(null);

  const filterAndSortFonts = (fontArray: Font[] = []) => {
    let fonts = [...fontArray];

    if (searchQuery.value) {
      fonts = fonts.filter((font) => {
        const query = searchQuery.value.toLowerCase();
        return (
          font.name.toLowerCase().includes(query) || font.fontName?.toLowerCase().includes(query)
        );
      });
    }

    return fonts.sort((a, b) => a.name.localeCompare(b.name));
  };

  const filteredBrandFonts = computed(() => filterAndSortFonts(brandFonts.value));
  const filteredSystemFonts = computed(() =>
    filterAndSortFonts(userFonts.value.filter((font: Font) => font.is_predefined)),
  );
  const filteredImportedFonts = computed(() =>
    filterAndSortFonts(userFonts.value.filter((font: Font) => !font.is_predefined)),
  );

  function showFontFamily(active: boolean) {
    isActive.value = active;

    if (active) {
      searchQuery.value = '';

      // Add auto-scroll functionality when dropdown is opened
      setTimeout(() => {
        const fontsModal = document.querySelector('.fonts-modal');
        if (fontsModal) {
          if (!noAutoScroll) {
            fontsModal.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest',
            });
          }

          // Wait for scroll to complete before focusing
          setTimeout(() => {
            if (searchInput.value) {
              (searchInput.value as HTMLInputElement).focus();
            }
          }, 500);
        }
      }, 0);
    }
  }

  function setFontFamily(value: string) {
    showFontFamily(false);
    selectedFont.value = value;
    emit('update:value', value);
  }

  function importFonts() {
    //
  }

  const clickOutsideOptions = ref({
    ignore: [fontFamilyButton.value],
  });

  // Adding event listener for ESC key to close the font selector
  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && isActive.value) {
      showFontFamily(false);
      event.stopPropagation();
    }
  }

  watch(isActive, (newValue) => {
    if (newValue) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }
  });

  onUnmounted(() => {
    if (isActive.value) {
      document.removeEventListener('keydown', handleKeyDown);
    }
  });

return { __sfc: true,store, emit, userFonts, brandFonts, defaultFonts, selectedFont, isActive, searchQuery, fontFamilyButton, fontsModal, searchInput, filterAndSortFonts, filteredBrandFonts, filteredSystemFonts, filteredImportedFonts, showFontFamily, setFontFamily, importFonts, clickOutsideOptions, handleKeyDown, BaseText, OnClickOutside }
}

})